import axios from '../../localAxios';
import { restoreWorkspaceQuizzesURL } from '../workspacesURLs';

interface RestoreWorkspaceFoldersParams {
  workspaceId: string;
  workspaceQuizIds: string[];
}

export async function restoreWorkspaceQuizzes({
  workspaceId,
  workspaceQuizIds,
}: RestoreWorkspaceFoldersParams) {
  const url = restoreWorkspaceQuizzesURL(workspaceId);
  return axios.put(url.href, { workspace_quiz_ids: workspaceQuizIds });
}
